import { render, staticRenderFns } from "./EmployeesGroup.vue?vue&type=template&id=51af8029"
import script from "./EmployeesGroup.vue?vue&type=script&lang=js"
export * from "./EmployeesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports